import { Home as HomeIcon } from '@mui/icons-material';

const Home = (): JSX.Element => <HomeIcon fontSize="inherit" />;

export default Home;
